export const APP_NAME = import.meta.env.VITE_APP_NAME || 'Sanjoy';
export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT || 'development';
export const SITE_URL =
  import.meta.env.VITE_SITE_URL ||
  (typeof window !== 'undefined' ? window.location.origin : 'https://sanjoy.ai');

/** Brand social profiles — leave blank to hide footer icons / omit sameAs. */
export const SOCIAL_LINKS = {
  linkedin: import.meta.env.VITE_SOCIAL_LINKEDIN || '',
  twitter: import.meta.env.VITE_SOCIAL_TWITTER || '',
  youtube: import.meta.env.VITE_SOCIAL_YOUTUBE || '',
} as const;

/** Twitter/X @handle for twitter:site (e.g. @sanjoyai). */
export const TWITTER_SITE = import.meta.env.VITE_TWITTER_SITE || '';

export const ROUTES = {
  HOME: '/',
  EXPLORE: '/explore',
  INDUSTRIES: '/industries',
  GOALS: '/goals',
  KNOWLEDGE: '/knowledge',
  WORKFLOWS: '/workflows',
  WORKFLOW_COMPARE: '/workflows/compare',
  CAPABILITIES: '/capabilities',
  PRODUCTS: '/products',
  ASK: '/ask',
  GRAPH: '/graph',
  SEARCH: '/search',
  ABOUT: '/about',
  TEAM: '/team',
  ASSOCIATE_PROGRAM: '/associate-program',
  /** @deprecated Use ASSOCIATE_PROGRAM — kept for legacy links */
  CAREER: '/career',
  PARTNERS: '/partners',
  RESOURCES: '/resources',
  LOGIN: '/login',
  PROFILE: '/profile',
  ADMIN: '/admin',
  UNAUTHORIZED: '/unauthorized',
} as const;

export type NavItemType = 'link' | 'mega-menu';

export interface NavItem {
  label: string;
  path: string;
  type: NavItemType;
  megaMenuKey?: 'industries' | 'goals' | 'products';
}

export const NAV_ITEMS: NavItem[] = [
  { label: 'Industries', path: ROUTES.INDUSTRIES, type: 'link' },
  { label: 'Products', path: ROUTES.PRODUCTS, type: 'mega-menu', megaMenuKey: 'products' },
  { label: 'Knowledge', path: ROUTES.KNOWLEDGE, type: 'link' },
  { label: 'Workflows', path: ROUTES.WORKFLOWS, type: 'link' },
  { label: 'About', path: ROUTES.ABOUT, type: 'link' },
];

export const COMPANY_SIZE_OPTIONS = [
  { value: '1-10', label: '1-10 employees' },
  { value: '11-50', label: '11-50 employees' },
  { value: '51-200', label: '51-200 employees' },
  { value: '201-500', label: '201-500 employees' },
  { value: '500+', label: '500+ employees' },
] as const;

export const CONTACT_METHOD_OPTIONS = [
  { value: 'email', label: 'Email' },
  { value: 'phone', label: 'Phone' },
  { value: 'video-call', label: 'Video Call' },
] as const;

export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1440,
} as const;
